var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-dialog',{model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('img',{staticClass:"qrCode",attrs:{"src":require("../../../static/img/qrCode.jpg")}}),_vm._v(" "),_c('div',{staticClass:"txt"},[_vm._v("\n      您的账号未开通会员功能或账号已过期。扫码添加文本基因计划客服，欢迎咨询、订阅开通文本基因会员功能。\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-166b327a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/promptBox/index.vue
// module id = null
// module chunks = 